var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.553 9.813a7.216 7.216 0 016.26-6.26C12.078 3.254 14.912 3 18 3c3.088 0 5.922.254 8.187.553a7.216 7.216 0 016.26 6.26C32.745 12.078 33 14.912 33 18a63.13 63.13 0 01-.553 8.187 7.216 7.216 0 01-6.26 6.26C23.922 32.745 21.088 33 18 33c-3.088 0-5.922-.254-8.187-.553a7.216 7.216 0 01-6.26-6.26C3.254 23.922 3 21.088 3 18c0-3.088.254-5.922.553-8.187z",
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.44 12.44a1.5 1.5 0 012.12 0L18 15.878l3.44-3.44a1.5 1.5 0 012.12 2.122L20.122 18l3.44 3.44a1.5 1.5 0 01-2.122 2.12L18 20.122l-3.44 3.44a1.5 1.5 0 01-2.12-2.122L15.878 18l-3.44-3.44a1.5 1.5 0 010-2.12z",
    fill: "#3699FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/Close.b30da0c2.svg";
export { ForwardRef as ReactComponent };